import React, { FC } from 'react'
import { useTable } from 'react-table'
import { USER_TABLE_COLUMNS } from './columns'
import { UserI } from '../../types'
import './UserTable.scss'

interface UserTablePropsI {
    user: UserI
}

const UserTable: FC<UserTablePropsI> = ({ user }) => {
    const columns = React.useMemo(() => USER_TABLE_COLUMNS, [])
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data: [user] })

    return (
        <>
            <table className='user-table' {...getTableProps()}>
                <thead className='user-table-header'>
                    {headerGroups.map(headerGroup => (
                        <tr className='user-table-row' {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <th className='user-table-header' {...column.getHeaderProps()}>{column.render('Header')}</th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map((row, i) => {
                        prepareRow(row)
                        return (
                            <tr className='user-table-row' {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                    return <td className='user-table-data' {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    )
}

export default UserTable